import React from "react";
import PropTypes from "prop-types";

const Header = ({ children, menuOpen = true, leftContent }) => {
  return (
    <header
      className="
      fixed top-0 inset-x-0 z-10 border-b border-line
       bg-surface"
    >
      <nav
        className={`
        w-full transition-[padding] duration-200 motion-reduce:transition-none
        ${menuOpen ? 'pl-56' : 'pl-14'} pr-4
        p-4
        h-14
        flex
        items-center
        justify-end`}
      >
        {leftContent && <div className="mr-auto min-w-0">{leftContent}</div>}
        <div className="flex shrink-0 items-center">
          {children}
        </div>
      </nav>
    </header>
  );
};

export default Header;

Header.propTypes = {
  children: PropTypes.any,
  menuOpen: PropTypes.bool,
  leftContent: PropTypes.node,
};
